export default () => {

    const dropdown = document.querySelector('[data-order-status]');
    if (dropdown) {
        dropdown.addEventListener('change', () => {
            document.querySelector('[name="status"]').value = dropdown.value;
            document.querySelector('[data-order-search]').submit();
        });
    }

}
